"use client";
import HeroSection from "@/components/common/HeroSection";
import Projects from "@/components/projects/Projects";

import { OurWorkData } from "@/constants/OurWorkData.js";

export default function OurWorkClientPage() {
  return (
    <div className="mt-6 mb-40 mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150]">
      <section className="flex flex-col items-center">
        <HeroSection
          heading="Our WORK"
          subHeading="What We’ve Built"
          paragraph="Our work is a blend of design thinking, technical excellence, and strategic innovation. Every solution we build tells a story - a story of collaboration, transformation, and digital progress that helps our clients achieve their business goals and engage users meaningfully."
          headingStyles="tracking-[0.04em] leading-[100%] text-center opacity-100 "
          paragraphStyles="xl:text-[30px] laptop:max-w-[1260px]"
        />
      </section>
      <section className="mt-[115px] xl:mt-0">
        {OurWorkData.map((project, index) => (
          <Projects key={index} project={project} index={index} />
        ))}
      </section>
    </div>
  );
}
